import { useLayoutEffect } from "react";

function useResizeLayoutEffect(onResize: () => void, enabled: boolean = true) {
  useLayoutEffect(() => {
    if (!enabled) return;

    onResize(); // initialize

    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [enabled, onResize]);
}
export default useResizeLayoutEffect;
